import script from "./AdminDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=c44ed24e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c44ed24e"]])

export default __exports__